module.exports = {"320481001":"昆仑街道","320481002":"溧城街道","320481003":"古县街道","320481101":"埭头镇","320481102":"上黄镇","320481103":"戴埠镇","320481106":"天目湖镇","320481107":"别桥镇","320481109":"上兴镇","320481111":"竹箦镇","320481114":"南渡镇","320481116":"社渚镇","320481400":"常州监狱","320481401":"溧阳监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320481.json
// module id = 962
// module chunks = 0